<!--已完成  -->
<template>
  <div class="finishIndent">
    <div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" :offset="20"
          v-if="isData" @load="onLoad">
          <div class="card" v-for="(item, index) in finishList" :key="index">
            <div class="invoice" v-if="showInvoice===index" @click="jumpInvoice(item)">  {{showStatus(item)}}</div>
            <div class="card-header">
              <div class="left"><span>{{ filtersStatus(item.status) }}</span><img  v-if="item.invoiceStatus||item.canApplyInvoice"  class="dot" @click="change(index)" src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/invoice/dot.png" alt=""></div>
              <div class="hint" v-if="item.status == 3 && item.needAddress == 1 && item.bindAddress == false">
                <span class="text">该订单含有配套资料，为了方便给你发货，请添加收货地址</span>
              </div>
            </div>
            <div class="card-body" @click="courseDetails(item.orderNo)">
              <div class="public" v-for="(course, index) in item.orderPackageProductRespList || item.orderProductList"
                :key="index">
                <div class="text">
                  <p class="name">
                    <i v-if="course.productName.substr(0, 1) == '【'" class="title-special-processing" />{{
                        course.productName
                    }}
                  </p>
                </div>
                <span class="pice" v-if="!hasAccommodationProduct(item.orderProductList)">￥{{ course.productPrice }}</span>
              </div>
              <!-- <div class="public">
                <div class="text">
                  <span>协议</span>
                  <p class="deal">
                  考研直播课程名称考研直播程名称考研直播课程名称考研直播程名称
                  </p>
                </div>
                <span class="pice">￥2000</span>
              </div>
              <div class="public">
                <div class="text">
                  <span>增值</span>
                  <p class="deal">
                    考研直播课程名称考研直播程名称考研直播课程名称考研直播程名称
                  </p>
                </div>
              <span class="pice">￥2000</span>
            </div> -->
            </div>
            <div class="card-footer">
              <div class="pay">
                <span>下单时间 {{ item.createTime }}</span>
                <div class="money">
                  <span>
                    <p>{{ filtersPayText(item.status) }}</p>
                    <p class="pice">￥{{item.channel==45?0:item.partnerOrder?item.orderTotalAmount:item.orderAmount}}</p>
                  </span>
                </div>
              </div>
              <div class="button">
                <div class="add-address" v-if="item.status == 3 && item.needAddress == 1 && item.bindAddress == false"
                  @click="addAddress(item.orderNo)">
                  添加地址
                </div>

                <div v-else-if="item.status == 3 && item.needAddress == 1 && item.bindAddress == true"
                  class="add-address" @click="shippedOrder(item.orderNo)">
                  发货信息
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <EmptyData :emptyName="'noIndent'" v-else />
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { reqOrderList } from '@/api/personal/orderController';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { orderType, selectPayText } from '../indentTools';

export default {
  data() {
    return {
      add: false,
      orderParam: {
        pageNum: 1,
        pageSize: 5,
        status: '3',
      },
      loading: false,
      finished: false,
      refreshing: false, // 下拉刷新
      finishList: [],
      finishTotal: 0,
      isData: true,
      showInvoice: -1
    };
  },

  components: {
    EmptyData,
  },

  computed: {},

  mounted() { },

  created() {
    this.getFinishList(this.orderParam);
  },
  methods: {
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {
      if (this.finishList.length >= this.finishTotal) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        this.orderParam.pageNum += 1;
        this.getFinishList(this.orderParam);
      }
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      // this.finishList = [];
      this.refreshing = true;
      this.orderParam.pageNum = 1;
      this.getFinishList(this.orderParam);
    },
    async getFinishList(data) {
      try {
        this.loading = true;
        const res = await reqOrderList(data);
        if (res.code === 0) {
          if (res.data.total === 0) {
            this.isData = false;
          }
          if (this.refreshing) {
            this.finishList = [];
          }
          this.refreshing = false;
          this.loading = false;
          res.data.data.forEach((item) => {
            const { orderPackageProductRespList } = item;
            (orderPackageProductRespList || []).forEach((child) => {
              Object.assign(child, { productName: child.packageName, productPrice: child.price });
            });
          });
          this.finishList.push(...res.data.data);
          this.finishTotal = res.data.total;
        } else {
          this.$toast(`请求异常！${res.msg}`);
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
    // 订单状态
    filtersStatus(status) {
      return orderType(status);
    },
    filtersPayText(status) {
      return selectPayText(status);
    },
    // 进入详情页
    courseDetails(orderNo) {
      this.$router.push({ path: '/indentDetail', query: { orderNo } });
    },
    // 添加地址
    addAddress(orderNo) {
      this.$router.push({ path: '/personalCenter/address', query: { orderNo, sourse: 1, isHideMask: true } });
    },
    // 发货信息
    shippedOrder() {
      this.$router.push({ path: 'myExpress' });
    },
    change(index){
      this.showInvoice=index===this.showInvoice?-1:index
    },
     jumpInvoice(data) {
      const { orderNo, invoiceStatus, canApplyInvoice } = data;
      if (canApplyInvoice) {
        this.$router.push({ path: '/invoiceIndex', query: { orderNo } });
      } else {
        this.$router.push({ path: '/invoiceDetail', query: { orderNo } });
      }
    },
     showStatus(data){
      const {invoiceStatus,canApplyInvoice}=data;
      return canApplyInvoice
        ? '申请开票'
        : invoiceStatus === 1 || invoiceStatus === 2|| invoiceStatus === 3
        ? '查看发票'
        : '';
    },
    hasAccommodationProduct(orderProductList) {
      const flag =
        (orderProductList)?.some((item) => item && item.isAccommodation === 1);

      return flag;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/style/indentCard.scss';

.finishIndent {
  .button {
    display: flex;
    justify-content: flex-end;

    .add-address {
      @include commonBtn(132px, 43px, $theme_color, 34px, 22px, $bgWhite);
    }
  }
}
</style>
